<template>
	<div>
		<!-- 自定义导航栏 -->
		<!-- <u-navbar back-text="即插即充设置"></u-navbar> -->
		<div class="content">
			<div class="top-title">
				个人信息收集清单
			</div>
			<div class="boxs">
				<div class="flexs bolds">
					<div>业务场景</div>
					<div>收集目的</div>
					<div>收集方式</div>
					<div>信息类型</div>
				</div>
				<div class="flexs">
					<div>帮助您成为我们的用户</div>
					<div>注册平台账号</div>
					<div>用户输入</div>
					<div>手机号、短信验证码、密码以及第三方平台昵称、账号、Open ID（可选）</div>
				</div>
				<div class="flexs">
					<div>帮助您绑定充电桩</div>
					<div>通过扫描或上传充电桩IMEI码绑定充电桩</div>
					<div>用户输入</div>
					<div>摄像头(相机)权限、相册权限</div>
				</div>
				<div class="flexs">
					<div>帮助您完成订单支付</div>
					<div>为确认用户订单支付状态</div>
					<div>系统采集</div>
					<div>支付时间、支付金额、支付渠道、支付流水号等支付信息</div>
				</div>
				<div class="flexs">
					<div>附近充电桩</div>
					<div>为便捷用户发现周边的充电站/充电桩</div>
					<div>系统采集</div>
					<div>位置权限</div>
				</div>
				<div class="flexs">
					<div>使用蓝牙模式（仅App平台及挚达支付宝小程序支持）</div>
					<div>通过蓝牙模式连接充电桩，使用蓝牙充电功能</div>
					<div>系统采集</div>
					<div>蓝牙权限</div>
				</div>
				<div class="flexs">
					<div>共享充电桩（仅挚达支付宝小程序支持）</div>
					<div>审核向平台内充电桩桩主申请共享使用授权的申请</div>
					<div>用户输入</div>
					<div>平台账号、手机号码、车辆型号</div>
				</div>
				<div class="flexs">
					<div>绑定您的车辆</div>
					<div>绑定用户新能源汽车</div>
					<div>用户输入</div>
					<div>车辆型号、车牌</div>
				</div>
				<div class="flexs">
					<div>个人信息维护</div>
					<div>完善个人信息</div>
					<div>用户输入</div>
					<div>微信头像、昵称、照片、出生年月日、性别、地区信息（可选）</div>
				</div>
				<div class="flexs">
					<div>客户服务</div>
					<div>与客服联系互动</div>
					<div>系统采集</div>
					<div>沟通记录、账号信息、订单信息</div>
				</div>
				<div class="flexs">
					<div>安全保障功能</div>
					<div>保障用户账号安全与系统运行安全</div>
					<div>系统采集</div>
					<div>
						IP地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、及您请求的网页记录以及设备相关信息（例如包括但不限于设备型号、名称、IMEI、设备MAC地址、软件列表、设备序列号、android
						ID）等信息或运行中的进程信息</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import tabbar from '../../component/tabbar.vue'
	export default {
		// components:{
		// 	tabbar
		// },
		data() {
			return {
				checked: null,
			}
		},
		onLoad() {

		},
		onReady() {

		},
		onShow() {

		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.content {
		box-sizing: border-box;
		padding: 16px;
		background-color: #fff;
		display: flex;
		height: 100%;
		flex-direction: column;

		.top-title {
			text-align: center;
			margin-top: 15px;
			font-size: 14px;
			font-weight: 800;
			margin-bottom: 10px;
		}

		.title-medim {
			margin-top: 15px;
			font-size: 13px;
			font-weight: 600;
			margin-bottom: 5px;
		}

		.contents {
			// text-indent: 2em;
			font-size: 12px;
			line-height: 18px;
		}

		.boxs {
			border: 1px solid #000000;

			.bolds {
				font-weight: 800;
				height: 40px;
				line-height: 40px;
				text-align: center;
			}

			.flexs {
				display: flex;
				border-bottom: 1px solid #000000;

				&:last-child {
					border-bottom: 0;
				}

				>div {
					flex: 1;
					align-items: center;
					justify-content: center;
					text-align: center;
					border-right: 1px solid #000000;

					&:last-child {
						border-right: 0 solid #000000;
					}
				}
			}
		}
	}
</style>
